
















































































import { Component, Vue } from "vue-property-decorator";
import "firebaseui/dist/firebaseui.css";
import * as firebase from "firebase/app";
import "firebase/auth";
import * as firebaseui from "firebaseui";
import "firebase/firestore";
const db = firebase.firestore();
import UserService from "@/services/UserService";
import moment from "moment";

@Component
export default class LoginApp extends Vue {
  email = "";
  password = "";
  message = "";
  remember = false;
  showPassword = false;
  firstLogin = false;
  googleIcon = "/btn_google_dark_normal_ios.svg";

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private ruleEmail: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => /.+@.+\..+/.test(v) || "有効なメールアドレスではありません。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private rulePassword: any = [
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (v: any) => !!v || "入力が必須です。",
  ];

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  get refs(): any {
    return this.$refs;
  }

  public mounted() {
    document.title = "favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "ログイン | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }

    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());

    const uiConfig: firebaseui.auth.Config = {
      callbacks: {
        signInSuccessWithAuthResult: (authResult) => {
          if (authResult.user) {
            this.afterSignInGoogle(authResult.user);
          }
          return false;
        },
      },
      signInSuccessUrl: "mypage/profile",
      signInOptions: [firebase.auth.GoogleAuthProvider.PROVIDER_ID],
      // TODO:Terms of service url.(サービス利用規約ページの)
      tosUrl: "",
      credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    };
    // use it after releasing
    // ui.start("#firebaseui-auth-container", uiConfig);
  }

  googleLogin() {
    const provider = new firebase.auth.GoogleAuthProvider();
    this.socialLogin(provider);
  }

  // TBD
  // facebookLogin() {
  //   const provider = new firebase.auth.FacebookAuthProvider();
  //   this.socialLogin(provider);
  // }

  // TBD
  // lineLogin() {
  //   const provider = new firebase.auth.OAuthProvider("<providerId>");
  //   this.socialLogin(provider);
  // }

  socialLogin(provider: any) {
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async (result: any) => {
          if (result.user && result.user.email !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            result.user.getIdToken().then((idToken: any) => {
              this.$store.dispatch("actionSetIdToken", idToken);
            });
            const uid = result.user.uid;
            // ローカルストレージにUIDを記録する
            localStorage.uid = uid;
            // ローカルストレージのプロファイル入力状態を初期化する(他の画面への遷移防止)
            localStorage.profileInput = "false";
            localStorage.login = "true";
            let response: any = {};
            response = await UserService.getUsers({
              email: result.user.email,
            });
            console.dir(response);
            // ユーザが存在しない(新規ソーシャルログイン)の場合、ユーザを作成する TODO:メール認証状態で登録したい
            if (response.data.users.length === 0) {
              this.firstLogin = true;
              await UserService.createUser({
                email: result.user.email,
                uid: result.user.uid
              });
              response = await UserService.getUsers({
                email: result.user.email
              });
            }

            if (response.data.users.length > 0) {
              await UserService.updateUser({
                last_login: moment().format()
              });
              const user = response.data.users[0];
              this.$store.dispatch("actionSetUser", user);
              const userName = user.last_name + " " + user.first_name;
              localStorage.userName = userName;
              // ローカルストレージにプロフィール入力状態を記録する
              localStorage.profileInput = "true";
              // 新規ソーシャルログイン
              if (this.firstLogin) {
                this.$router.push({ name: "SettingProfile" });
              }
              // ローカルストレージにpathがあればそこに遷移する
              if (!user.custom_id) {
                this.$router.push({ name: "SettingProfile" });
              } else {
                this.$router.go(-1);
              }
            } else {
              this.logout();
            }
          }
        },
        () => {
          //エラー系
          this.message = "メールアドレスもしくはパスワードが異なります。";
        }
      );
  }

  signIn() {
    this.message = "";
    if (this.refs.loginForm.validate()) {
      this.doSignIn();
    }
  }

  doSignIn() {
    if (this.remember) {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL);
    } else {
      firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
    }
    firebase
      .auth()
      .signInWithEmailAndPassword(this.email, this.password)
      .then(
        async (result) => {
          if (result.user && result.user.email !== undefined) {
            result.user.getIdToken().then((idToken) => {
              this.$store.dispatch("actionSetIdToken", idToken);
            });
            const uid = result.user.uid;
            // ローカルストレージにUIDを記録する
            localStorage.uid = uid;
            // ローカルストレージのプロファイル入力状態を初期化する(他の画面への遷移防止)
            localStorage.profileInput = "false";
            localStorage.login = "true";
            // メールアドレス認証だったらメール認証状態をチェック
            // 必要に応じてメール認証確認画面に遷移
            if (!result.user.emailVerified) {
              // this.$router.push({ name: "SignupNotValid" });
              this.navigateToSignupNotValid(result.user);
            } else {
              const response = await UserService.getUsers({
                email: result.user.email,
              });

              if (response.data.users.length > 0) {
                await UserService.updateUser({
                  last_login: moment().format()
                });
                const user = response.data.users[0];
                this.$store.dispatch("actionSetUser", user);
                const userName = user.last_name + " " + user.first_name;
                localStorage.userName = userName;
                // ローカルストレージにプロフィール入力状態を記録する
                localStorage.profileInput = "true";
                // ローカルストレージにpathがあればそこに遷移する
                if (!user.custom_id) {
                  this.$router.push({ name: "SettingProfile" });
                } else {
                  this.$router.go(-1);
                }
              } else {
                this.logout();
              }
            }
          }
        },
        () => {
          //エラー系
          this.message = "メールアドレスもしくはパスワードが異なります。";
        }
      );
  }

  logout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        this.$store.commit("clearAuthState");
        localStorage.uid = "";
        localStorage.profileInput = "false";
        localStorage.userName = "";
        this.message = "メールアドレスもしくはパスワードが異なります。";
      });
  }

  navigateToSignupNotValid(user: any) {
    // firebase
    //   .auth()
    //   .signOut()
    //   .then(() => {
    this.$store.commit("clearAuthState");
    localStorage.uid = "";
    localStorage.profileInput = "false";
    localStorage.userName = "";
    localStorage.emailNotVerified = user.email;
    this.$router.push({ name: "SignupNotValid" });
    //   });
  }

  async afterSignInGoogle(user: any) {
    // ローカルストレージにUIDを記録する
    localStorage.login = "true";
    localStorage.uid = user.uid;
    const response = await UserService.getUsers({ email: user.email });
    const idToken = await user
      .getIdToken()
      .then((idToken: string) => {
        this.$store.dispatch("actionSetIdToken", idToken);
        return idToken;
      })
      .catch((err: any) => null);
    if (!idToken) return;
    this.$store.dispatch("actionSetIdToken", idToken);
    if (response.data.users.length > 0) {
      const dataUser = response.data.users[0];
      this.$store.dispatch("actionSetUser", dataUser);
      localStorage.userName = dataUser.last_name + " " + dataUser.first_name;
      // ローカルストレージにプロフィール入力状態を記録する
      localStorage.profileInput = "true";
      if (dataUser.custom_id) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: "SettingProfile" });
      }
    } else {
      try {
        const responseCreateUser = await UserService.createUser({
          email: user.email,
          uid: user.uid,
        });

        this.$store.dispatch("actionSetUser", responseCreateUser.data.user);
        // ローカルストレージにプロフィール入力状態を記録する
        localStorage.profileInput = "false";
        // プロフィール登録前ならプロフィール登録に遷移する
        this.$router.push({ name: "SettingProfile" });
      } catch (err) {
        this.logout();
      }
    }
  }
}
